// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementContentBlockLocalesResult = arrayOf(
  objectOf({
    content_block_id: string,
    content_block_name: string,
    locales: arrayOf(
      objectOf({
        id: string,
        name: string,
        locale_key: string,
      })
    ),
  })
);
